import React, {useState} from 'react';
import {MDBIcon} from "mdb-react-ui-kit";
import './SubjectColumn.css';
import SubjectSelect from "./SubjectSelect";

export const SubjectColumn = {
    format: (value) => {
        return (
            <SubjectColumnDisplay
                value={value}
            />
        );
    }
};

const SubjectColumnDisplay = ({ value }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        isExpanded ?
            (<SubjectSelect
                value={value}
                onCancel={() => setIsExpanded(false)}
            />)
            : (
                <div
                    onClick={() => setIsExpanded(true)}
                    className={'position-relative custom_subject_column'}
                >
                    {value === '' ? (<div className={'ps-4'}> — </div>) : (
                        <ul>
                            {value.split(";").map((val, index) => (
                                <li key={index}>{val}</li>
                            ))}
                        </ul>
                    )}
                    <MDBIcon
                        fas
                        icon="pen-to-square"
                        className="text-secondary position-absolute top-0 end-0 custom_subject_column_icon"
                        size='md'
                    />
                </div>
            )
    );
};

export default SubjectColumn;
